import React from 'react'
import styled from 'styled-components'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import {brandIvory} from "../../../assets/consts/color";

const Container = styled.div`
    aspect-ratio: 1 / 1;
    overflow: hidden;
    position: relative;
    display: grid;
    place-content: center;
    background: ${brandIvory};
    
    width: 270px;
    height: 232px;
    
    @media screen and (min-width: 42em) {
        width: 310px;
        height: 272px;
    }
    
    img {
      display: block;
      object-fit: contain;
      width: 90%;
      height: 90%;
      justify-self: center;
      align-self: center;
    }

    &:before {
        background-image: url(${ImageCut});
        background-position: top left;
        background-size: cover;
        content: '';
        height: 30px;
        left: -1px;
        position: absolute;
        top: -1px;
        transform: rotate(180deg);
        width: 30px;
        z-index: 1;
    }
`

function IndustryPartnerCard({ title, url }) {
  return (
    <Container>
        <img src={url} alt={title} />
    </Container>
  )
}

export default IndustryPartnerCard
